module.exports = __webpack_public_path__ + "static/img/m_name.2e6d514.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/swbnzk/m_name.png
// module id = 27rD
// module chunks = 7